import { createSelector, createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLoading: false,
  isActive: false,
  id: 0,
  uid: 0,
  sid: 0,
  blockContent: {
    items: [],
    heading: {
      title: '',
      description: '',
      textAlign: 'left',
      image: '',
      divider: '',
      position: '',
    },
  },
  blockDesign: {
    view: 'feed',
    layout: '1',
  },
  itemDesign: {},
  containerDesign: {},
};

export const unlockSlice = createSlice({
  name: 'unlock',
  initialState,
  reducers: {
    unlockStore: (state, action) => {
      const { id, isActive, sid, uid, data } = action.payload;
      const block = data ?? {};
      const { blockContent, blockDesign } = block;
      const { itemDesign, containerDesign } = blockDesign;

      state.isLoading = false;
      state.id = id ?? 0;
      state.isActive = isActive;
      state.sid = sid;
      state.uid = uid;

      state.itemDesign = itemDesign ?? {};
      state.containerDesign = containerDesign ?? {};

      state.blockContent = {
        items: blockContent.items ?? [],
        heading: {
          title: blockContent.heading?.title ?? '',
          description: blockContent.heading?.description ?? '',
          textAlign: blockContent.heading?.textAlign ?? 'left',
          image: blockContent.heading?.image ?? '',
          divider: blockContent.heading?.divider ?? '',
          position: blockContent.heading?.position ?? '',
        },
      };

      state.blockDesign = {
        view: blockDesign.view ?? 'feed',
        layout: blockDesign.layout ?? '1',
      };
    },
    unlockClear: () => initialState,
    unlockUpdateIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    unlockUpdateIsActive: (state, action) => {
      state.isActive = action.payload;
    },
    unlockUpdateBlockContent: (state, action) => {
      state.blockContent = action.payload;
    },
    unlockUpdateBlockDesign: (state, action) => {
      state.blockDesign = action.payload;
    },
  },
});

export const { unlockStore, unlockClear, unlockUpdateIsLoading, unlockUpdateIsActive, unlockUpdateBlockContent, unlockUpdateBlockDesign } = unlockSlice.actions;

export const selectUnlockIsLoading = (state) => state.unlock.isLoading;
export const selectUnlockId = (state) => state.unlock.id;
export const selectUnlockUID = (state) => state.unlock.uid;
export const selectUnlockSID = (state) => state.unlock.sid;
export const selectUnlockBlockContent = (state) => state.unlock.blockContent;
export const selectUnlockBlockDesign = (state) => state.unlock.blockDesign;
export const selectUnlockSortItems = createSelector([selectUnlockBlockContent], ({ items }) => items ?? []);
export const selectUnlockItemDesign = (state) => state.unlock.itemDesign;
export const selectUnlockContainerDesign = (state) => state.unlock.containerDesign;

export default unlockSlice.reducer;
